import { CDN_BASE_URL } from '../../utils/config';

const CDN = `${CDN_BASE_URL}/images/consumer`;

export const ACCEPT_ICON = `${CDN}/accept.svg`;
export const ACCOUNT_USAGE_PERSON_ICON = `${CDN}/account-usage-person.svg`;
export const ACC_ICON = `${CDN}/acc-icon.png`;
export const ACH_METHOD_ICON = `${CDN}/ach-method.svg`;
export const ACH_METHOD_LIGHT_ICON = `${CDN}/ach-method-light.svg`;
export const ACK_SEARCH_ICON = `${CDN}/ack-search.png`;
export const ADD_ICON = `${CDN}/add.svg`;
export const ADD_PINK_ICON = `${CDN}/add-pink.svg`;
export const ADD_RECIPIENT_WHITE_ICON = `${CDN}/add-recipient-white.svg`;
export const ADD_VISA_ICON = `${CDN}/add-visa.svg`;
export const ALERT_ICON = `${CDN}/alert.svg`;
export const ALERT_BELL_ICON = `${CDN}/alert-bell.svg`;
export const ALERT_BLACK_ICON = `${CDN}/alert-black.svg`;
export const ALL_CARDS_ICON = `${CDN}/all-cards-new.svg`;
export const COUPON_TAG = `${CDN}/coupon-tag.svg`;
export const ALERT_EXCLAIMATION_ICON = `${CDN}/alert-exclaimation.svg`;
export const AMAZE_BANNER_CARD_ICON = `${CDN}/amaze-banner-card.svg`;
export const AMAZE_BANNER_CARD_MOBILE_ICON = `${CDN}/amaze-banner-card-mobile.svg`;
export const AMAZE_CARD_ICON_1 = `${CDN}/amaze-card-icon-1.svg`;
export const AMAZE_CARD_ICON_2 = `${CDN}/amaze-card-icon-2.svg`;
export const AMAZE_CARD_ICON_3 = `${CDN}/amaze-card-icon-3.svg`;
export const AMAZE_CARD_NEW_ICON = `${CDN}/amaze-card-new.png`;
export const AMAZE_CLOSE_ICON = `${CDN}/amaze-close.svg`;
export const AMAZE_ICON = `${CDN}/amaze-icon.svg`;
export const AMAZE_ICON_STRETCH = `${CDN}/amaze-icon-stretch.png`;
export const AMAZE_SMALL_ICON = `${CDN}/amaze-small.png`;
export const AMAZE_CARD_SMALL_ICON = `${CDN}/amaze-small.svg`;
export const AMEX_ICON = `${CDN}/amex.jpg`;
export const AMEX_LITE_ICON = `${CDN}/amex-lite.jpg`;
export const APPLE_STORE_ICON = `${CDN}/apple-store.svg`;
export const APPROVED_ICON = `${CDN}/approved.png`;
export const APPROVE_NEW_ICON = `${CDN}/approve-new.svg`;
export const APP_PROMOTION_ICON = `${CDN}/app-promotion.svg`;
export const ARROW_LEFT_ICON = `${CDN}/arrow-left.svg`;
export const ARROW_DOWN_ICON = `${CDN}/arrow-down.svg`;
export const ATTACHEMENT_ICON = `${CDN}/attachement.svg`;
export const ATTEST_ICON = `${CDN}/attest.svg`;
export const AWAITING_PAYMENT_ICON = `${CDN}/awaiting-payment.svg`;
export const BACK_ARROW_SVG_ICON = `${CDN}/back-arrow.svg`;
export const BACK_ARROW_ICON = `${CDN}/back-arrow.png`;
export const BACK_BUTTON_ONBOARDING_ICON = `${CDN}/back-button-on-boarding.png`;
export const BANK = `${CDN}/bank.svg`;
export const BANK_CIRCLE_ICON = `${CDN}/bank-icon-circle.svg`;
export const BANK_ICON_NEW = `${CDN}/bank-icon-new.svg`;
export const BANK_STATEMENT_ICON = `${CDN}/bank-statement.svg`;
export const BANK_TRANSFER_METHOD_ICON = `${CDN}/bank-transfer-method.svg`;
export const BANK_TRANSFER_METHOD_LIGHT_ICON = `${CDN}/bank-transfer-method-light.svg`;
export const BETTER_FX_ICON = `${CDN}/better-fx-icon.svg`;
export const BINOCULARS_HELP_CENTER_ICON = `${CDN}/binoculars-help-center.svg`;
export const BIGGER_WALLET_ICON = `${CDN}/wallet.png`;
export const BLUE_CALENDER_ICON = `${CDN}/blue-calender-icon.svg`;
export const BLUE_EMAIL_ICON = `${CDN}/blue-email-icon.svg`;
export const BLUE_NEW_HEART_ICON = `${CDN}/blue-new-heart.svg`;
export const BLUE_WARNING_ICON = `${CDN}/blue-warning.svg`;
export const BOLT_ICON = `${CDN}/bolt.svg`;
export const BSI_LOGO_ICON = `${CDN}/bsi-logo.svg`;
export const BULB_ICON = `${CDN}/bulb.svg`;
export const CALL_US_ICON = `${CDN}/call-us.svg`;
export const CAMERA_FLIP_ICON = `${CDN}/camera-flip-icon.svg`;
export const CANCEL_ICON = `${CDN}/cancel-icon.svg`;
export const CARD_ICON = `${CDN}/card-icon.svg`;
export const CARD_ICON_AMAZE_CARD = `${CDN}/card-icon-amaze-card.svg`;
export const CARD_ICON_INVITE = `${CDN}/card-icon-invite.svg`;
export const CARD_ICON_TRANSFER_OVERSEAS = `${CDN}/card-icon-transfer-overseas.svg`;
export const COUPON_ICON = `${CDN}/coupon.png`;
export const CARET_DOWN_NEW_ICON = `${CDN}/caret-down-new.svg`;
export const CARET_DOWN_NEW_GREY_ICON = `${CDN}/caret-down-new-grey.svg`;
export const CARET_LEFT_BLACK_ICON = `${CDN}/caret-left-black.png`;
export const CARET_RIGHT_BLUE_ICON = `${CDN}/caret-right-blue.svg`;
export const CARET_UP_NEW_ICON = `${CDN}/caret-up-new.svg`;
export const CASH_ICON = `${CDN}/cash-icon.svg`;
export const CASH_TRANSFER_UP_METHOD_ICON = `${CDN}/cash-transfer-up-method.svg`;
export const CARTES_CARD_ICON = `${CDN}/cartes-card.svg`;
export const CHAT_ICON = `${CDN}/chat.svg`;
export const CHAT_PEOPLE_ICON = `${CDN}/chat-people.svg`;
export const CHAT_SEND_ICON = `${CDN}/chat-send.svg`;
export const CHECK_ICON = `${CDN}/check.svg`;
export const CHECKBOX_NEW_ICON = `${CDN}/checkbox-new.svg`;
export const CHECKED_ICON = `${CDN}/checked-icon.png`;
export const CHECKMARK_ICON = `${CDN}/checkmark.svg`;
export const CALENDAR_BLACK_OUTLINE_ICON = `${CDN}/calendar-black-outline.svg`;
export const CHECKMARK_BLACK_ICON = `${CDN}/checkmark-black.svg`;
export const CHECK_BLUE_ICON = `${CDN}/check_blue.svg`;
export const CHEVRON_LEFT_ICON = `${CDN}/chevron-left.svg`;
export const CHEVRON_LEFT_WHITE_ICON = `${CDN}/chevron-left-white.svg`;
export const CHEVRON_RIGHT_ICON = `${CDN}/chevron-right.svg`;
export const CHEVRON_RIGHT_LIGHT_ICON = `${CDN}/chevron-right-light.svg`;
export const CHEVRON_RIGHT_WHITE_ICON = `${CDN}/chevron-right-white.svg`;
export const CIRCLE_CHECK_ICON = `${CDN}/circle-check.svg`;
export const CIRCLE_CHECK_BLACK_ICON = `${CDN}/circle-check-black.svg`;
export const CLOSE = `${CDN}/close.svg`;
export const CLOSE_BOLD_ICON = `${CDN}/close-bold.svg`;
export const CLOSE_HEAVY_ICON = `${CDN}/close-heavy.svg`;
export const CLOSE_NEW_ICON = `${CDN}/close-new-icon.svg`;
export const CLOSE_POPUP_ICON = `${CDN}/close-popup.svg`;
export const COMPARISION_ICON = `${CDN}/comparision.svg`;
export const CONVERGING_BELOW_LIGHT_ICON = `${CDN}/converging-below-light.svg`;
export const COOL_ICON = `${CDN}/cool.svg`;
export const COPY_ICON = `${CDN}/copy-icon.svg`;
export const COPY_SBM_ICON = `${CDN}/copy-sbm.svg`;
export const CORRECT_ICON = `${CDN}/correct.png`;
export const CROSS_ICON = `${CDN}/cross.svg`;
export const CURRENCY_CHANGE_ICON = `${CDN}/currency_change.png`;
export const CURRENCY_PINK_ICON = `${CDN}/currency-pink.svg`;
export const CURRENT_LOCATION_PIN_ICON = `${CDN}/current-location-pin.svg`;
export const DEBIT_CARD_METHOD_ICON = `${CDN}/debit-card-method.png`;
export const DELETE_ICON = `${CDN}/delete.svg`;
export const DIGI_LOCKER_ADHAAR_ICON = `${CDN}/digi-locker-adhaar.png`;
export const DROPDOWN_ARROW_ICON = `${CDN}/dropdown-arrow.png`;
export const DISABLED_ICON = `${CDN}/disabled.svg`;
export const DISCOVER_ICON = `${CDN}/discover.jpg`;
export const DISCOVER_LITE_ICON = `${CDN}/discover-lite.jpg`;
export const DOCUMENT_ID_ICON = `${CDN}/document-id-icon.svg`;
export const DOCUMENT_ID_ICON_DUAL_TONE = `${CDN}/document-id-icon-dual-tone.svg`;
export const DOT_LOADER_ICON = `${CDN}/dot-loader.svg`;
export const DOUBLE_MESSAGE_ICON = `${CDN}/double-message.svg`;
export const DOWNLOAD_HELP_CENTER_ICON = `${CDN}/download-help-center.svg`;
export const DOWNLOAD_RECEIPT_ICON = `${CDN}/download-receipt.png`;
export const DOWNLOAD_SBM_ICON = `${CDN}/download-sbm.svg`;
export const DOWNLOAD_PINK_ICON = `${CDN}/download-pink.svg`;
export const DOWN_CHEVERON_NEW_ICON = `${CDN}/down-cheveron-new.svg`;
export const DOWN_CHEVRON_LIGHT_ICON = `${CDN}/down-chevron-light.svg`;
export const DOC_FILE_ICON = `${CDN}/doc-file.svg`;
export const DRIVING_LICENSE_ICON = `${CDN}/driving-license-icon.svg`;
export const DROPDOWN_ICON = `${CDN}/dropdown-icon.svg`;
export const DROPDOWN_LIGHT_ICON = `${CDN}/dropdown-light.svg`;
export const EARTH_ICON = `${CDN}/earth.svg`;
export const EDIT_ICON = `${CDN}/edit.svg`;
export const EDIT_CONTACT_ICON = `${CDN}/edit-contact.svg`;
export const EDIT_ICON_MULTI_TXN_ICON = `${CDN}/edit-icon-multi-txn.png`;
export const EMPLOYMENT_PASS_ICON = `${CDN}/employment-pass.svg`;
export const EMPTY_STAR_ICON = `${CDN}/empty-star.svg`;
export const ERROR = `${CDN}/error.png`;
export const ERROR_ICON = `${CDN}/error-icon.svg`;
export const EXCHANGE_ICON = `${CDN}/exchange-icon.svg`;
export const EXTRACT_PHONE_ICON = `${CDN}/extract-phone.svg`;
export const FACEBOOK_INVITE_ICON = `${CDN}/facebook-icon-invite.svg`;
export const FAILED_IMG_ICON = `${CDN}/failed-img.png`;
export const FAQ_ICON = `${CDN}/faq.png`;
export const FEEDBACK_IMG_ICON = `${CDN}/feedback-img.png`;
export const FILLED_CHECKBOX_ICON = `${CDN}/filled-checkbox.svg`;
export const FIN_BACK_ICON = `${CDN}/fin-back.svg`;
export const FIN_FRONT_ICON = `${CDN}/fin-front.svg`;
export const FLASH_ICON = `${CDN}/flash-icon.svg`;
export const FLOATING_LABEL_MY_INFO_ICON = `${CDN}/floating-label-my-info.svg`;
export const GLOBAL_ICON = `${CDN}/global.svg`;
export const GLOBAL_LOCKED_ICON = `${CDN}/global-locked.svg`;
export const GMAIL_ICON_INVITE_ICON = `${CDN}/gmail-icon-invite.svg`;
export const GOOD_ICON = `${CDN}/good.svg`;
export const GOOGLE_NEW_LOGO_ICON = `${CDN}/google-new-logo.svg`;
export const GOOGLE_PLAY_STORE_ICON = `${CDN}/google-play-store.svg`;
export const GOVERNMENT_ICON = `${CDN}/government.svg`;
export const GREEN_CHECK_ICON = `${CDN}/green-check.svg`;
export const GREY_DOWN_ARROW_ICON = `${CDN}/grey-down-arrow.svg`;
export const GREY_QUESTION_MARK_ICON = `${CDN}/grey-question-mark.svg`;
export const HAND_ICON = `${CDN}/hand.svg`;
export const HEART_ICON = `${CDN}/heart.svg`;
export const HIDE_EYE_ICON = `${CDN}/hide-eye.svg`;
export const HILL_BLUE_ICON = `${CDN}/hill-blue.svg`;
export const HISTORY_ICON = `${CDN}/history-icon.svg`;
export const HOW_IT_WORKS_ICON = `${CDN}/how-it-works.png`;
export const ID_CARD_FILL_ICON = `${CDN}/id-card-fill.png`;
export const INFO = `${CDN}/info.svg`;
export const INFORMATION_ICON_BLACK_BOLD_ICON = `${CDN}/information-icon-black-bold.svg`;
export const INFO_GREY_ICON = `${CDN}/info-grey-icon.svg`;
export const INFO_NEW_ICON = `${CDN}/info-new.svg`;
export const INFO_TIMELINE_ICON = `${CDN}/info-timeline-icon.png`;
export const INNER_CIRCLE_CROSS_ICON = `${CDN}/inner-circle-cross.svg`;
export const INSTAPOINTS_DOWN_ARROW_ICON = `${CDN}/instapoints-down-arrow.svg`;
export const INSTAPOINTS_DOWN_ARROW_GREEN_ICON = `${CDN}/instapoints-down-arrow-green.svg`;
export const INSTAPOINTS_ICON = `${CDN}/instapoints-icon.svg`;
export const INSTAREM_APP_QR_CODE_ICON = `${CDN}/instaremApp_qr_code.svg`;
export const BLUE_ELLIPSE = `${CDN}/ellipse-blue.svg`;
export const INSTAREM_LOGO_ICON = `${CDN}/instarem-logo.svg`;
export const INSTAREM_NIUM_FOREX_LOGO_ICON = `${CDN}/instarem-nium-forex-logo.svg`;
export const INSTAREM_QRCODE_ICON = `${CDN}/instarem_qrcode.svg`;
export const INSTAREM_WHITE_LOGO_ICON = `${CDN}/instarem-white-logo.svg`;
export const INSTAREM404_ERROR_ICON = `${CDN}/InstaReM404.error.png`;
export const INTERACT_ICON = `${CDN}/interact.png`;
export const INVITE_ICON = `${CDN}/invite-icon.svg`;
export const IN_DRIVING_BACK_ICON = `${CDN}/in-driving-back.svg`;
export const IN_DRIVING_FRONT_ICON = `${CDN}/in-driving-front.svg`;
export const IN_PASSPORT_BACK_ICON = `${CDN}/in-passport-back.svg`;
export const IN_PASSPORT_FRONT_ICON = `${CDN}/in-passport-front.svg`;
export const IN_VOTER_BACK_ICON = `${CDN}/in-voter-back.svg`;
export const IN_VOTER_FRONT_ICON = `${CDN}/in-voter-front.svg`;
export const IP_FAST_EXPIRE_ICON = `${CDN}/ip_fast_expire_icon.svg`;
export const IP_NOTHING_EXPIRE_ICON = `${CDN}/ip_nothing_expire_icon.svg`;
export const IP_SLOW_EXPIRE_ICON = `${CDN}/ip_slow_expire_icon.svg`;
export const JUST_A_BIT_OF_WAIT_ICON = `${CDN}/just-a-bit-of-wait.svg`;
export const LINKEDIN_INVITE_ICON = `${CDN}/linkedin-icon-invite.svg`;
export const LOADER_ICON = `${CDN}/loader.svg`;
export const LOCATION_PIN_ICON = `${CDN}/location-pin.svg`;
export const LOGOUT_ICON = `${CDN}/logout-icon.svg`;
export const LOVE_ICON = `${CDN}/love.svg`;
export const MAD_UPDATE_ICON = `${CDN}/mad-update.svg`;
export const MAIL_ICON = `${CDN}/mail.svg`;
export const MANAGE_PAYMENT_OPT_ICON = `${CDN}/manage-payment-opt.svg`;
export const MAP_PIN_ICON = `${CDN}/map-pin.svg`;
export const MASTERCARD_SMALL_ICON = `${CDN}/master-card-small.svg`;
export const MASTERCARD_ICON = `${CDN}/mastercard.svg`;
export const MASTERCARD_LITE_ICON = `${CDN}/mastercard-lite.svg`;
export const MINIMIZE_CARD_ICON = `${CDN}/minimize-card.svg`;
export const MOBILE_CIRCLE_ICON = `${CDN}/mobile-circle.svg`;
export const MOBILE_ICON = `${CDN}/mobile-icon.svg`;
export const MOBILE_NUMBER_ONBOARDING_ICON = `${CDN}/mobile-number-onboarding.svg`;
export const MOBILE_PNG_ICON = `${CDN}/mobile-png.png`;
export const MOBILE_SCREEN_HALF = `${CDN}/mobile-screen-half.png`;
export const MY_ACCOUNT_ICON = `${CDN}/my-account-icon.svg`;
export const MY_ACCOUNT_SBM_ICON = `${CDN}/my-account-icon-sbm.svg`;
export const MY_INFO_LOGO_ICON = `${CDN}/my-info-logo.jpg`;
export const MY_INFO_MOBILE_ICON = `${CDN}/my-info-mobile.svg`;
export const NEW_ICON = `${CDN}/new.svg`;
export const NEWBACKWITHOUT_CIRCLE_ICON = `${CDN}/new-back-without-circle.svg`;
export const NEW_ADD_REF_ICON = `${CDN}/new-add-ref.svg`;
export const NEW_APP_PRICING_ICON = `${CDN}/new-app-pricing.svg`;
export const NEW_CLOSE_ICON = `${CDN}/new-close.svg`;
export const NEW_STAR_FILLED_ICON = `${CDN}/new-star-filled.svg`;
export const NEW_INSTAREM_LOGO_ICON = `${CDN}/new-instarem-logo.svg`;
export const NEW_INSTAREM_MONEY_SIMPLE_ICON = `${CDN}/new-instarem-money-simple.svg`;
export const NIUM_FOREX_ICON = `${CDN}/nium-forex-icon.svg`;
export const NIUM_FOREX_STEPS_NEW_ICON = `${CDN}/nium-forex-steps-new.svg`;
export const NIUM_FOREX_SUCCESS_ICON = `${CDN}/nium-forex-success.svg`;
export const NOTE_PAD_ICON = `${CDN}/note-pad.svg`;
export const NOTIFICATION_ICON = `${CDN}/notification-icon.svg`;
export const NOTIFICATION_ICON_SBM_ICON = `${CDN}/notification-icon-sbm.svg`;
export const NRIC_ICON = `${CDN}/nric.svg`;
export const NRIC_BACK_ICON = `${CDN}/nric-back.svg`;
export const ONE_ICON = `${CDN}/one.svg`;
export const ONGOING_CHAT_ICON = `${CDN}/ongoing-chat-icon.svg`;
export const ORANGE_INFO_ICON = `${CDN}/orange-info-icon.svg`;
export const OR_TEXT_ICON = `${CDN}/or-text.svg`;
export const OUTLINED_CALENDAR_ICON = `${CDN}/outlined-calendar.svg`;
export const PAID_TRANSACTION_ICON = `${CDN}/paid-transaction.svg`;
export const PAN_CARD_ICON = `${CDN}/pan-card.svg`;
export const PAN_SAMPLE_ICON = `${CDN}/pan-sample.svg`;
export const PASSWORD_GOOD_ICON = `${CDN}/password-good-icon.svg`;
export const PAYEE_BACK_ICON = `${CDN}/payee-back.svg`;
export const PAYMENT_FAILED_ICON = `${CDN}/payment-failed.svg`;
export const PAY_ID_ICON = `${CDN}/pay-id.jpg`;
export const PAY_ID_LITE_ICON = `${CDN}/pay-id-lite.jpg`;
export const PAY_NOW_ICON = `${CDN}/pay-now.png`;
export const PDF_ICON = `${CDN}/pdf-icon.svg`;
export const PDF_FILE_ICON = `${CDN}/pdf-file.svg`;
export const PENDING_PAYMENT_VERIFICATION_ICON = `${CDN}/pending-payment-verification.svg`;
export const PERSONAL_INFORMATION_ICON = `${CDN}/personal-information.svg`;
export const PERSON_ICON = `${CDN}/person.png`;
export const PIGGY_BANK_ICON = `${CDN}/piggy-bank-icon.svg`;
export const PINK_ARROW_ICON = `${CDN}/pink-arrow.svg`;
export const PINK_ELIPSE_ICON = `${CDN}/pink-elipse.svg`;
export const PLUS_ICON = `${CDN}/plus.svg`;
export const POWERED_BY_NIUM_FOREX_LOGO = `${CDN}/powered-by-nium-forex-logo.svg`;
export const PREVIEW_NOTE_ICON = `${CDN}/preview-note.png`;
export const PROCESSING_ICON = `${CDN}/processing-icon.svg`;
export const PROCESS_PAYMENT_ICON = `${CDN}/process-payment.svg`;
export const PROFILE_ICON = `${CDN}/profile-icon.svg`;
export const PROFILE_ICON_NEW = `${CDN}/profile-icon-new.svg`;
export const QUESTION_MARK_ICON = `${CDN}/question-mark.svg`;
export const RATING_STAR_ICON = `${CDN}/rating-star.svg`;
export const RATING_STAR_GOLDEN_ICON = `${CDN}/rating-star-golden.svg`;
export const RECIPIENT_ICON = `${CDN}/recipient.svg`;
export const RECIPIENTS = `${CDN}/recipients.svg`;
export const RECURRING_TRANSFER_ICON = `${CDN}/recurring-transfer.svg`;
export const REFERRAL_ICON = `${CDN}/referral.svg`;
export const REFERRAL_SMALL_ICON = `${CDN}/referral-small.svg`;
export const REJECT_ICON = `${CDN}/reject.svg`;
export const REPORT_BILL_ICON = `${CDN}/report-bill-icon.svg`;
export const REQUIRED_INFO_ICON = `${CDN}/required-info.svg`;
export const RESET_BACK_ICON = `${CDN}/reset-back.svg`;
export const REWIND_ICON = `${CDN}/rewind-icon.svg`;
export const RIGHT_ARROW_SVG_ICON = `${CDN}/right-arrow.svg`;
export const RIGHT_ARROW_ICON = `${CDN}/right-arrow.png`;
export const RIGHT_ARROW_BLACK_ICON = `${CDN}/right-arrow-black.svg`;
export const RIGHT_TRIANGLE_ICON = `${CDN}/right-triangle.svg`;
export const ROUND_CORNER_ICON = `${CDN}/round-corner.svg`;
export const ROUND_CROSS_ICON = `${CDN}/round-cross.svg`;
export const ROUND_DASH_ICON = `${CDN}/round-dash.svg`;
export const ROUND_EQUALS_ICON = `${CDN}/round-equals.svg`;
export const SAD_UPDATE_ICON = `${CDN}/sad-update.svg`;
export const SAMPLE = `${CDN}/sample.svg`;
export const SAMPLE_ICON = `${CDN}/sample-icon.svg`;
export const SAMPLE_PASSPORT_IMAGE_ICON = `${CDN}/sample-passport-image.svg`;
export const SAMPLE_PHOTO_EU_ICON = `${CDN}/sample-photo-eu.jpg`;
export const SAMPLE_PHOTO_SG_ICON = `${CDN}/sample-photo-sg.png`;
export const SBM_LOGO_SVG_ICON = `${CDN}/sbm-logo.svg`;
export const SBM_LOGO_ICON = `${CDN}/sbm-logo.jpg`;
export const SCAN_PHONE_ICON = `${CDN}/scan-phone.svg`;
export const SEARCH_ICON = `${CDN}/search.svg`;
export const SEARCH_SMALL_ICON = `${CDN}/search-small.svg`;
export const SELFIE_WITH_ID_ICON = `${CDN}/selfie-with-id.svg`;
export const SEND_ML_ICON = `${CDN}/send-ml-icon.svg`;
export const SEND_MONEY_BANK_ICON = `${CDN}/send-money-bank.svg`;
export const SEND_MONEY_CASH_PICKUP_ICON = `${CDN}/send-money-cash-pickup.svg`;
export const SEND_MONEY_ICON = `${CDN}/send-money-icon.svg`;
export const SEND_MONEY_PROXY_ICON = `${CDN}/send-money-proxy.svg`;
export const SHOW_EYE_ICON = `${CDN}/show-eye.svg`;
export const SMALL_CALENDAR_PINK_ICON = `${CDN}/small-calendar-pink.svg`;
export const SOLID_VERTICAL_LINE_ICON = `${CDN}/solid-vertical-line.svg`;
export const SSN_FAILED_ICON = `${CDN}/ssn-failed.svg`;
export const STAR_ICON = `${CDN}/star.svg`;
export const STAR_PINK_ICON = `${CDN}/star-pink.svg`;
export const STOPWATCH_ICON = `${CDN}/stopwatch.svg`;
export const STROKED_LINE_ICON = `${CDN}/stroked-line.svg`;
export const STROKED_VERTICAL_ICON = `${CDN}/stroked-vertical-line.svg`;
export const STROKED_VERTICAL_LINE_ICON = `${CDN}/stroked-vertical-line.svg`;
export const SUBSCRIPTION_ICON = `${CDN}/subscription-icon.svg`;
export const SHIELD_ICON = `${CDN}/shield-icon.svg`;
export const SUCCESSFUL_COMPLETION_ICON = `${CDN}/successful-completion.svg`;
export const SUCCESS_GREEN_TICK_ICON = `${CDN}/success-green-tick.png`;
export const SUCCESS_SUBMIT_ICON = `${CDN}/success_submit.svg`;
export const THREE_ICON = `${CDN}/three.svg`;
export const THUMBS_DOWN_BLACK_ICON = `${CDN}/thumbs-down-icon-black.svg`;
export const THUMBS_DOWN_PINK_ICON = `${CDN}/thumbs-down-icon-pink.svg`;
export const THUMBS_UP_BLACK_ICON = `${CDN}/thumbs-up-icon-black.svg`;
export const THUMBS_UP_PINK_ICON = `${CDN}/thumbs-up-icon-pink.svg`;
export const TICKET_SUCCESS_ICON = `${CDN}/ticket-success-icon.svg`;
export const TIMELINE_BULLET_COMPLETED_ICON = `${CDN}/timeline-bullet-completed.svg`;
export const TIME_ICON = `${CDN}/time-icon.svg`;
export const TOOLTIP_ICON = `${CDN}/tooltip-icon.svg`;
export const TRANSACTION_BEFORE_LIGHT_ICON = `${CDN}/transaction-before-light.svg`;
export const TRANSACTION_BEFORE_WHITE_ICON = `${CDN}/transaction-before-white.svg`;
export const TRANSACTION_SEARCH_CALENDAR_ICON = `${CDN}/transaction-search-calendar.svg`;
export const TRANSACTION_SEARCH_CALENDER_LIGHT_ICON = `${CDN}/transaction-search-calender-light.svg`;
export const TRANSACTION_SEARCH_STATUS_ICON = `${CDN}/transaction-search-status.svg`;
export const TRANSACTION_TIMELINE_ACTIVE_ICON = `${CDN}/transaction-timeline-active.svg`;
export const TRANSACTION_TIMELINE_DISABLE_ICON = `${CDN}/transaction-timeline-disable.svg`;
export const TRANSACTION_TIMELINE_RFI_RAISED_ICON = `${CDN}/transaction-timeline-rfi-raised.svg`;
export const TRANSFER_DOLLAR_ICON = `${CDN}/transfer-dollar.svg`;
export const TWITTER_INVITE_ICON = `${CDN}/twitter-icon-invite.svg`;
export const TWO_ICON = `${CDN}/two.svg`;
export const UNREAD_INDICATOR_ICON = `${CDN}/unread-indicator.svg`;
export const UPLOAD_BACK_ICON = `${CDN}/upload-back-icon.svg`;
export const UPLOAD_CAMERA_ICON = `${CDN}/upload-camera.svg`;
export const UPLOAD_FILE_ICON = `${CDN}/upload-file.svg`;
export const UPLOAD_FRONT_ICON = `${CDN}/upload-front-icon.svg`;
export const UPLOAD_ICON = `${CDN}/upload-icon.svg`;
export const UPSELL_POPUP_HEADER_ICON = `${CDN}/upsell-popup-header-icon.svg`;
export const USER_ML_ICON = `${CDN}/user-ml-icon.svg`;
export const USER_WITH_CARD_ICON = `${CDN}/user-with-card.svg`;
export const UTILITY_ICON = `${CDN}/utility.svg`;
export const VERIFICATION_LOADING_ICON = `${CDN}/verification-loading.svg`;
export const VIDEO_FILE_ICON = `${CDN}/video-file.svg`;
export const VISA_SVG_ICON = `${CDN}/visa.svg`;
export const VISA_ICON = `${CDN}/visa-icon.png`;
export const VISA_CARD_SVG_ICON = `${CDN}/visa-card.svg`;
export const VISA_MASTER_ICON = `${CDN}/visa-master.png`;
export const WALLET_ICON = `${CDN}/wallet.svg`;
export const WARNING_ICON = `${CDN}/warning-icon.svg`;
export const WATCH_ICON = `${CDN}/watch.svg`;
export const WHATSAPP_INVITE_ICON = `${CDN}/whatsapp-icon-invite.svg`;
export const WHAT_DO_YOU_THINK_ICON = `${CDN}/what-do-you-think.svg`;
export const WIRE_TRANSFER_ICON = `${CDN}/wire-transfer.svg`;
export const WIRE_TRANSFER_SELECTED_ICON = `${CDN}/wire-transfer-selected.svg`;
export const YOUR_SIGNATURE_ICON = `${CDN}/your-signature.svg`;
export const DISABLED_EDIT_ICON = `${CDN}/edit-icon-disabled.svg`;
export const CARD_PERCENTAGE_ICON = `${CDN}/card-percentage.svg`;
export const PAYTO_MOBILE = `${CDN}/mobile_payto.svg`;
export const PAYTO_LOGO = `${CDN}/payto-logo.svg`;
export const BANK_STATEMENT_SAMPLE = `${CDN}/bank-statement-sample.svg`;
export const CAMERA_ICON = `${CDN}/camera.svg`;
export const PASSPORT_ICON = `${CDN}/passport-icon.svg`;
export const MOBILE_WALLET_ICON = `${CDN}/money-wallet.svg`;
export const SMALL_FLASH_ICON = `${CDN}/small-flash-icon.svg`;
export const GET_APP_MOBILE_QR_IMAGE = `${CDN}/get-app-mobile-qr-image.svg`;
export const THUNDER_ICON = `${CDN}/thunder-icon.svg`;
export const SCISSOR_ICON = `${CDN}/scissor.svg`;
export const BLACK_WHITE_SEND_ICON = `${CDN}/black-white-send.svg`;
export const ADD_PERSON_ICON = `${CDN}/add-person.svg`;
export const BW_WALLET_ICON = `${CDN}/wallet-2.svg`;
export const CASHBACK_AND_KRISFLYER = `${CDN}/web-revamp/krisflyer-miles.svg`;
export const REFERRAL_AVATARS_IMG = `${CDN}/web-revamp/referral-placeholder-image.png`;
export const INSTAPOINTS_COIN_ICON = `${CDN}/balance-dark.svg`;
